export class UsuarioBc {
    cpf: string;
    email: string;
    foto: string;
    nome: string;
    dataLogin: any;
}



// WEBPACK FOOTER //
// ./src/app/model/usuario-bc.ts